var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.79 270.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.4,0c49.59,0,74.39,19.79,74.39,59.35v22.95c0,13.99-2.31,25.66-6.92,35.02-4.62,9.37-12.33,17.87-23.15,25.52l-32.05,24.14c-12.14,8.71-20.18,15.96-24.14,21.76-3.96,5.8-5.94,14.11-5.94,24.93v22.95h91.8v33.63H0v-59.35c0-16.09,3.29-29.02,9.89-38.78,6.59-9.76,16.48-19.25,29.68-28.49l33.63-26.12c7.65-5.01,12.79-10.42,15.43-16.22,2.63-5.8,3.96-13.71,3.96-23.74v-15.04c0-9.5-2.64-16.55-7.91-21.17-5.28-4.61-16.16-6.92-32.64-6.92s-32.38,3.04-47.68,9.1V7.52C18.86,2.51,35.87,0,55.4,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.aa131abbf53d8122ec8bbbfc2891644f.svg";
export { ForwardRef as ReactComponent };